module.exports = __webpack_public_path__ + "static/media/partiesActive.4ea53fc8.svg";